export const positions = ['24 24', `
<path d="M15 16.9286V6.25H13.75V16.973L11.0225 14.2456L10.1387 15.1294L14.3528 19.3436L18.5669 15.1294L17.6831 14.2456L15 16.9286Z" />
<path d="M6.22781 0.678711L2.01367 4.89289L2.89754 5.77675L5.625 3.04929V13.7501H6.875V3.09367L9.55809 5.77675L10.4419 4.89289L6.22781 0.678711Z" />
`];
